import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

type ITextBoxProps = {
	name: string;
	value: string;
	onValueChanged: (value: string) => void;
	label?: string;
	error?: string;
	sizeClass?: 'xs' | 'sm' | 'md' | 'lg';
	helpBlock?: string;
	placeholder?: string;
	type?: string;
	labelSmall?: boolean;
	isDisabled?: boolean;
	hasValid?: boolean;
	className?: string;
	classWrapper?: string;
};

export const TextBox = ({
	value,
	error,
	name,
	label,
	type,
	sizeClass,
	isDisabled,
	helpBlock,
	labelSmall,
	hasValid,
	placeholder,
	className,
	classWrapper,
	onValueChanged,
}: ITextBoxProps) => {
	const showError = !!error;
	return (
		<div className={cn("space-y-2", classWrapper)}>
			{label && (
				<Label htmlFor={name} className={cn(labelSmall && "text-xs")}>
					{label} {hasValid && <span className='text-destructive'>(*)</span>}
				</Label>
			)}
			<div className="relative">
				<Input
					id={name}
					type={type || 'text'}
					name={name}
					value={value || ''}
					disabled={isDisabled}
					placeholder={placeholder}
					onChange={(e) => onValueChanged(e.target.value)}
					className={cn(showError && "border-destructive", className)}
				/>
			</div>
			{showError && <p className="text-sm font-medium text-destructive">{error}</p>}
			{helpBlock && <p className="text-sm text-muted-foreground" dangerouslySetInnerHTML={{ __html: helpBlock }} />}
		</div>
	);
};
